import { render } from "./CollaboratorsDrawer.vue?vue&type=template&id=8d1ef93c&scoped=true"
import script from "./CollaboratorsDrawer.vue?vue&type=script&lang=js"
export * from "./CollaboratorsDrawer.vue?vue&type=script&lang=js"

import "./CollaboratorsDrawer.vue?vue&type=style&index=0&id=8d1ef93c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1ef93c"]])

export default __exports__